import { ICONS, ToasterMode } from '@creditsights/styleguide-web';
import { atom } from 'recoil';

export interface ToasterConfig {
  text: string;
  bold?: boolean;
  icon?: ICONS;
  timeout?: number;
  mode?: ToasterMode;
}

export const toasterState = atom<ToasterConfig>({
  key: 'toasterMessageState',
  default: {
    text: '',
    bold: false,
    icon: ICONS.Check,
  },
});
